import { SHOPIFY_TEMPLATE_TYPES } from '~/constants/shopify';

/**
 * Dynamic Yield campaign names used across the site
 * Centralizing these constants ensures consistency and easier maintenance
 */

/**
 * Global campaigns that are used across multiple components
 */
export const GLOBAL_CAMPAIGNS = {
  MULTI_TOUCH_TEST: 'Multi-Touch Rebrand Campaign',
};

/**
 * Recommendations campaigns selectors
 */
export const RECOMMENDATIONS_CAMPAIGNS = {
  [SHOPIFY_TEMPLATE_TYPES.ARTICLE]: 'Article - Recs',
  [SHOPIFY_TEMPLATE_TYPES.COLLECTION]: 'Collection Personalized Merchandising',
  [SHOPIFY_TEMPLATE_TYPES.INDEX]: 'Homepage - Recs',
  [SHOPIFY_TEMPLATE_TYPES.NOT_FOUND_ERROR]: 'Not found - Recs',
  [SHOPIFY_TEMPLATE_TYPES.PAGE]: 'Page - Recs',
  [SHOPIFY_TEMPLATE_TYPES.PRODUCT]: 'PDP Sidebar Recs',
};

/**
 * Campaign status constants
 */
export const CAMPAIGN_STATUS = {
  ERROR: 'error',
  SUCCESS: 'success',
};

/**
 * Engagement types constants
 */
export const ENGAGEMENT_TYPES = {
  CLICK: 'CLICK',
  IMPRESSION: 'IMP',
  SLOT_CLICK: 'SLOT_CLICK',
  SLOT_IMPRESSION: 'SLOT_IMP',
};
